export function ButtonViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element messenger-button">',
        '<div class="button-label"></div>',
        '<div class="button-sublabel"></div>',
        '<div class="item-edit-container"><span class="glyphicon glyphicon-pencil item-edit"></span></div>',
      '</div>'
    ].join(''),

    initialize: function() {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // Hook edition icon click handler (this.$box is initialized by the abstract superclass)
      this.$box.find('.item-edit').on('click', () => this.editButton());
    },

    // Event handler that shows a modal dialog for editing this messenger button
    editButton: function(evt) {

      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('./dialogs/editButton.modal.html'),
        controller: 'editButtonController',
        resolve: {
          button: () => angular.copy(this.model.get('button'))
        }
      });
      modalInstance.result.then(result => this.afterEditButton(result));
    },

    // private method called when the modal is closed and a result is resolved
    afterEditButton: function (result) {
      let parent = this.model.getAncestors()[0];
      let parentView = this.paper.findViewByModel(parent);
      if(result.type === 'delete') {
        this.model.remove();
        parentView.enableOrDisableAddButtons();
        //we save the graph on remove cell event

      } else if (result.type === 'edit') {
        this.model.set('button', result.button);
        callbacks.updateSerializedGraph(this.model.graph);
      }
      //Resize needed for both editing and deleting
      parentView.resizeBox();
    },

    /**
     * As postback button can have outgoing links,
     * but web URL buttons cannot,
     * we need to update the port accordingly after editing the button,
     * possibly removing an existing outgoing link  
     */
    updatePortAndLink: function() {
      if (this.model.hasPort('out') && !this.currentTypeHasOutPort()) {
        this.model.removeOutPort('out');
      } else if (!this.model.hasPort('out') && this.currentTypeHasOutPort()) {
        this.model.addOutPort('out');
      }
    },

    /**
     * Tells whether this button should have an outPort
     * and hence can be connected to other boxes of the graph,
     * depending on its selected type.
     */
    currentTypeHasOutPort() {
      return    this.model.get('button').type === 'postback'
             || this.model.get('button').type === 'login';
    },

    updateBox: function() {
      if(this.paper) {
        this.updatePortAndLink();
        const button = this.model.get('button');
        let label = button.title;
        let sublabel = '';
        if (button.type === 'login') {
          label = services.$translate.instant('parameters/quick_replies/details/graph/login_button_label_in_diagram');
        }
        if (button.type === 'web_url' || button.type === 'login') {
          sublabel = button.url;
        }
        this.$box.find('.button-label').text(label);
        this.$box.find('.button-sublabel').text(sublabel);
      }
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
    },

  });
}
